import { useCometState } from '#pplx/frontend/apps/ask/comet-browser/providers/EntropyBrowserHooks.js';
import { useSelectedSearchMode } from '#pplx/frontend/apps/ask/hooks/selected-search-mode-hooks/useSelectedSearchMode.js';
import { isPersonalizedQuerySource } from '#pplx/frontend/apps/ask/suggest-dropdown/utils/personalizedQuerySource.js';
import { domainFromURL } from '#pplx/frontend/common/files/urls.js';
import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useCallback, useRef } from 'react';
const autoSuggestionBlankStateViewedEvent = EVENT_PAYLOAD;
export function useAskInputSuggestionView({ inputQuery, querySource, }) {
    const { track } = useInstrumentation();
    const queryRef = useRef(inputQuery);
    queryRef.current = inputQuery;
    const searchMode = useSelectedSearchMode();
    const { sidecarSourceTab: { url: sidecarUrl }, } = useCometState();
    /**
     * For now this only logs blank state suggestions.
     * Logging every suggestion would fire 2x set of suggestions
     * - Once for new typed character with stale results, once with fresh results
     *
     * Eventually if we want to log every suggestion view, we should debounce
     * - Only log if not typed for X seconds
     */
    const handleSuggestionsView = useCallback((suggestions) => {
        if (queryRef.current.length !== 0) {
            return;
        }
        const isPersonalizedVertical = isPersonalizedQuerySource(querySource);
        const events = suggestions.map((suggestion, index) => ({
            name: 'auto suggestion blank state viewed',
            data: {
                mode: 'dropdown-complete',
                query: queryRef.current,
                ...(isPersonalizedVertical
                    ? { querySource, isPersonalized: true }
                    : { completion: suggestion.query }),
                completion_uuid: suggestion.query_uuid,
                completion_position: index,
                ...(isPersonalizedVertical ? {} : { url: suggestion.url }),
                isNavigational: !!suggestion.url,
                searchMode,
                sourceDomain: import.meta.env.VITE_IS_SIDECAR_BUILD
                    ? domainFromURL(sidecarUrl)
                    : undefined,
            },
        }));
        events.forEach((event) => track(autoSuggestionBlankStateViewedEvent(event)));
    }, [querySource, searchMode, track, sidecarUrl]);
    return handleSuggestionsView;
}
//# sourceMappingURL=useAskInputSuggestionView.js.map